import { gql } from "@apollo/client";

export const ADMIN_DASHBOARD_QUERY = gql`
  query AdminDashboard {
    productsCount
    campaignsCount
  }
`;
